'use client';

import { useCallback, useEffect, useState } from 'react';

const STATE_KEY = 'similarBaseItemCd';

const readState = (): string | undefined => {
  const itemCd = (window.history.state as Record<string, unknown> | null)?.[
    STATE_KEY
  ];
  return typeof itemCd === 'string' && itemCd ? itemCd : undefined;
};

export function useSimilarBaseProduct({
  enabled = true,
}: { enabled?: boolean } = {}): {
  /** 이 LP 로 돌아왔을 때 복원된 마지막 클릭 상품 코드 */
  similarBaseItemCd: string | undefined;
  /** 상품 클릭 시 기록 */
  rememberSimilarBase: (itemCd: string) => void;
} {
  const [similarBaseItemCd, setLastClickedItemCd] = useState<string>();

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const read = () => {
      const itemCd = readState();
      if (itemCd) {
        setLastClickedItemCd(itemCd);
      }
    };
    read();
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        read();
      }
    };
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        read();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pageshow', onPageShow);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('pageshow', onPageShow);
    };
  }, [enabled]);

  const rememberSimilarBase = useCallback((itemCd: string) => {
    window.history.replaceState(
      { ...(window.history.state ?? {}), [STATE_KEY]: itemCd },
      ''
    );
  }, []);

  return { similarBaseItemCd, rememberSimilarBase };
}
